// Module
var code = `<button id="hiddenPropertyButton-{{property.id}}" (click)="initProperty()" hidden></button>
<div *ngIf="newPropertyGroupId(property.propertyGroupId, currentIndex) && property.propertyGroup !== undefined"
     class="HOA-container collapsible HOA-container--border-tb u-mB6"
     (click)="showHidePropertyGroup(property.propertyGroupId)"
     id="collapsible-propertyGroup-{{property.propertyGroupId}}">

    <div class="HOA-container__header-nickname-text
                    HOA-container__header-text
                    HOA-propertyblock-flextable__cell--100">
        <div class="HOA-flex-center-info-button">
            <span class="Icon Icon--24 icon-utility-basics-folder-24 u-iconBlue">
                <svg focusable="false"
                     xmlns="http://www.w3.org/2000/svg"
                     width="24"
                     height="24"
                     viewBox="0 0 72 72">
                    <title>Related Accounts Group</title>
                </svg>
            </span>
            <label tid="propertyGroupLabel" style="margin-left: 5px">
                {{property.propertyGroup.nickname}}
            </label>
        </div>
    </div>
</div>
<div [class]="{'activeContent': property.propertyGroupId === 0}"
     class="HOA-container HOA-container--border-tb u-mB6 hiddenContent"
     id="content-{{property.id}}-propertyGroup-{{property.propertyGroupId}}">
    <div class="HOA-container collapsible" (click)="showHide(property.id)"
         id="collapsible-{{property.id}}">
        <div *ngIf="property.nickname"
             class="HOA-container__header-nickname-text
                        HOA-container__header-text--green
                        HOA-propertyblock-flextable__cell--100"
             [ngStyle]="property.propertyGroupId !== 0 && {'margin-left':'25px'}">
            {{property.nickname}}
        </div>
    </div>
    <div [class]="{'activeContent': propertiesSize === 1}"
         class="HOA-container HOA-container--border-tb u-mB6 hiddenContent"
         id="content-{{property.id}}">
        <div class="HOA-container HOA-container--border-tb">
            <div class="HOA-container__header">
                <!--TODO add {{property.hoa.contactInformation.displayName}}-->
                <div class="HOA-container__header-text HOA-container__child--flex-full" tid="hoaDisplayName">
                    <div class="HOA-propertyblock-flextable__header-text-2">{{property.hoa.name}}</div>
                    <div>
                            <span class="HOA-propertyblock-flextable__header-text-1">
                                Managed by  {{property.hoa.pmc.couponId}}
                            </span>
                        <button class="HOA-propertyblock-flextable__header-text-3"
                                [routerLink]="['/properties', property.hoa.pmc.couponId, 'hoadetails']">
                            {{property.hoa.pmc.name}}
                        </button>
                    </div>
                    <div *ngIf="property.propertyGroupId !== 0">
                        <span class="HOA-propertyblock-flextable__header-text-1">Related Accounts Group: </span>
                        <button class="HOA-propertyblock-flextable__header-text-3"
                                [routerLink]="['/properties/propertyGroup', property.propertyGroupId]">
                            {{property.propertyGroup.nickname}}
                        </button>
                    </div>
                    <div *ngIf="property.propertyGroupId === 0 &&
                                        ((property.groupCandidates && property.groupCandidates.length > 0) ||
                                         (property.availableGroups && property.availableGroups.length > 0))">

                        <!-- Create New Group -->
                        <span *ngIf="property.groupCandidates &&
                                            property.groupCandidates.length > 0 &&
                                            property.availableGroups.length === 0"
                              class="HOA-propertyblock-flextable__cell-value u-pB6">
                                    This address is part of multiple entities that require separate payments.
                                    Please click here to make a payment or add a schedule for this additional entity.
                                </span>
                        <button class="Button Button--blue u-margin-right-align"
                                id="createGroupButton"
                                [routerLink]="['/properties/propertyGroup', 'create', property.id]">
                            Add Entity
                        </button>

                        <!-- Add to Existing Group -->
                        <span *ngIf="property.groupCandidates.length === 0 &&
                                            property.availableGroups.length === 1"
                              class="HOA-propertyblock-flextable__header-text-1">
                                    Related Accounts Group:
                                </span>
                        <button *ngIf="property.groupCandidates.length === 0 &&
                                                property.availableGroups.length === 1"
                                class="Button Button--blue u-margin-right-align" id="addToGroupButton"
                                (click)="addToExistingGroup(property.availableGroups[0].id)">
                            Add to Existing Group
                        </button>

                        <!-- Manage Group Membership -->
                        <span *ngIf="(property.availableGroups.length === 1 &&
                                            property.groupCandidates.length > 0) ||
                                            property.availableGroups.length > 1"
                              class="HOA-propertyblock-flextable__header-text-1">
                                Related Accounts Group:
                            </span>
                        <button *ngIf="(property.availableGroups.length === 1 &&
                                            property.groupCandidates.length > 0) ||
                                            property.availableGroups.length > 1"
                                class="Button Button--blue u-margin-right-align"
                                id="manageGroupsButton1"
                                [routerLink]="['/properties/propertyGroup/multiRelationShips', property.id]">
                            Manage Group Membership
                        </button>
                    </div>
                </div>
                <app-pmc-logo [property]="property"></app-pmc-logo>
            </div>
        </div>
        <div class="HOA-container HOA-container--border-tb">
            <div class="HOA-container__header HOA-container__header--wrap-ifSizeIsSmall">
                <button class="HOA-container__header-nickname-text
                               HOA-propertyblock-flextable__cell--100
                               HOA-cursor-pointer u-textLeft
                               HOA-container__header-text--blue"
                        tid="propertyNickname"
                        [routerLink]="['/properties', property.id, 'details']">
                    <div ifOverFlowXClass="u-display-flex">
                        <span *ngIf="property.nickname"
                              class="HOA-container__header-nickname-text
                                     HOA-propertyblock-flextable__cell--100
                                     HOA-container__header-text--blue">
                            {{property.nickname}}
                        </span>
                        <!-- this should always be visible, even when truncating (which is why it's
        nested in flex containers) -->
                        <span class="Icon Icon--18 icon-utility-arrows-carrot_right-18 u-strokeGreenDarker" [hidden]="userStore.getSsoOrigin()"></span>
                    </div>
                </button>
                    <div class="HOA-container__header-paymentbutton-wrapper-outer
                                HOA-propertyblock-flextable__cell--100">
                        <div class="HOA-container__header-paymentbutton-wrapper-inner"
                             (click)="makePayment();\$event.stopPropagation();">
                            <button class="Button Button--blue u-margin-right-align HOA-container__header-paymentbutton"
                                    type="button"
                                    tid="makePaymentButton">
                                Make a Payment
                            </button>
                        </div>
                        <!--<div *ngIf="property.onHold">Unable to accept payment.  L01</div>-->
                        <!--<div *ngIf="property.isMigrate">We are unable to accept a payment at this time for this property.  Please contact your management company for more information.  M01</div>-->
                    </div>
</div>
            <div class="HOA-container__content
                            HOA-container__content--borderNone
                            HOA-container__content--lessPaddingTop">
                <!-- Hiding the balance summary display
                    <app-property-line-item-details
                        [tid]="'PropertyLineItemDetails'"
                        [propertyId]="property.id"
                        [property]="property">
                </app-property-line-item-details>-->
                <div class="HOA-propertyblock-flextable">
                    <div class="HOA-propertyblock-flextable__cell
                                    HOA-propertyblock-flextable__cell--list
                                    HOA-propertyblock-flextable__cell--100
                                    u-mT4
                                    u-margin-bottom-0-i
                                    u-word-break">
                        <div class="HOA-propertyblock-flextable__cell-value ql-editor"
                             tid="questionAboutAccount"
                             *ngIf="property.propertyContent && property.propertyContent.length > 0">
                            <div *ngFor="let content of property.propertyContent" class="u-mB6">
                                <app-custom-content [contentMessage]="content.msg"></app-custom-content>
                            </div>
                        </div>
                        <div class="HOA-propertyblock-flextable__cell-value u-pB6"
                             tid="questionAboutAccount"
                             *ngIf="property.propertyContent && property.propertyContent.length === 0">
                            Questions about your account? Contact your
                            <a tid="questionLink"
                               [routerLink]="['/contact']"
                               [queryParams]="{pmcId: property.hoa.pmc.couponId}">
                                management company.
                            </a>
                        </div>
                    </div>
                </div>
                <!-- SECTION: SCHEDULED PAYMENTS -->
                <div class="HOA-propertyblock-flextable">
                    <div class="HOA-container__content-hrule
                                    HOA-propertyblock-flextable__cell
                                    HOA-propertyblock-flextable__cell--100
                                    u-mT5">
                    </div>
                    <div *ngIf="property.scheduleContent &&
                                    property.scheduleContent.length > 0 &&
                                    property.paymentSchedules &&
                                    property.paymentSchedules.length === 0"
                         class="HOA-propertyblock-flextable__cell
                                    HOA-propertyblock-flextable__cell--list
                                    HOA-propertyblock-flextable__cell--100
                                    u-margin-bottom-0-i
                                    u-word-break">
                        <div class="HOA-propertyblock-flextable__cell-value ql-editor" tid="scheduleContent">
                            <div *ngFor="let content of property.scheduleContent" class="u-mB6">
                                <app-custom-content [contentMessage]="content.msg"></app-custom-content>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="HOA-flex-center-info-button HOA-container__header--wrap-ifSizeIsSmall u-pB5"
                     tid="schedulePaymentsSection">
                    <div class="HOA-propertyblock-flextable__cell--100 u-textLeft">
                        <span class="HOA-propertylanding-content__subheader">Scheduled Payments</span>
                    </div>
                    <div class="HOA-container__header-paymentbutton-wrapper-outer
                                    HOA-propertyblock-flextable__cell--100">
                        <div class="HOA-container__header-paymentbutton-wrapper-inner"
                             (click)="schedulePayment();makePayment();\$event.stopPropagation();">
                            <button class="Button
                                                Button--blue
                                                u-margin-right-align
                                                HOA-container__header-paymentbutton"
                                    type="button">
                                Add a Schedule
                            </button>
                        </div>
                    </div>
                </div>
                <div class="HOA-propertyblock-flextable">
                    <div *ngIf="property.scheduleContent &&
                                    property.scheduleContent.length > 0 &&
                                    property.paymentSchedules &&
                                    property.paymentSchedules.length > 0"
                         class="HOA-propertyblock-flextable__cell
                                    HOA-propertyblock-flextable__cell--list
                                    HOA-propertyblock-flextable__cell--100
                                    u-margin-bottom-0-i
                                    u-word-break">
                        <div class="HOA-propertyblock-flextable__cell-value" tid="scheduleContent">
                            <div *ngFor="let content of property.scheduleContent" class="u-mB6">
                                <app-custom-content [contentMessage]="content.msg"></app-custom-content>
                            </div>
                        </div>
                    </div>
                </div>
                <app-payment-schedule [paymentSchedules]="property.paymentSchedules"
                                      [isPaymentMethodView]="false">
                </app-payment-schedule>
                <!-- SECTION: PAYMENT HISTORY -->
                <div class="HOA-container__content-hrule
                                HOA-propertyblock-flextable__cell
                                HOA-propertyblock-flextable__cell--100 u-mT5">
                </div>
                <div class="HOA-propertylanding-content__subheader
                                HOA-propertyblock-flextable__cell
                                HOA-propertyblock-flextable__cell--100"
                     tid="paymentHistoryHeader">
                    Payment History
                    <a [routerLink]="['/properties', property.id, 'paymentHistory']"
                       [state]="{propertyId: property.id, paymentHistory: property.paymentHistory, property: property}"
                       tid="paymentHistoryViewAll"
                       class="u-mR0 u-marginLeft-auto u-fontSmall"
                       *ngIf="property.paymentHistory && property.paymentHistory.length > 0">
                        View All
                    </a>
                </div>
                <app-payment-history
                        [paymentHistory]="property.paymentHistory"
                        [property]="property"
                        [limit]="5">
                </app-payment-history>
            </div>
        </div>
    </div>
</div>`;
// Exports
module.exports = code;